import React from "react";

import classes from "./Input.module.css";

const input = (props) => {
  let inputElement = null;
  const inputClasses = [classes.InputElement];

  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push(classes.Invalid);
  }

  switch (props.elementType) {
    case "input":
      if (props.inputType === "password") {
        inputElement = (
          <input
            className={inputClasses.join(" ")}
            type="password"
            {...props.elementConfig}
            value={props.value}
            onChange={props.changed}
            placeholder={props.placeholder}
            onKeyPress={props.onKeyPress}
            onBlur={props.onBlur}
          />
        );
      } else {
        inputElement = (
          <input
            className={inputClasses.join(" ")}
            {...props.elementConfig}
            value={props.value}
            onChange={props.changed}
            placeholder={props.placeholder}
            onKeyPress={props.onKeyPress}
          />
        );
      }
      break;
    case "textarea":
      inputElement = (
        <textarea
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
          placeholder={props.placeholder}
          style={{ height: "150px" }}
          onKeyPress={props.onKeyPress}
        />
      );
      break;
    case "checkbox":
      inputElement = (
        <div>
          <input
            type="checkbox"
            className={classes.CheckBox}
            checked={props.checked}
            onChange={props.handleChange}
            onKeyPress={props.onKeyPress}
          />
          <label className={classes.CheckBoxLabel}>{props.label}</label>
        </div>
      );
      break;
    case "select":
      inputElement = (
        <select
          className={inputClasses.join(" ")}
          style={{ fontWeight: "600", color: "#166873" }}
          value={props.value}
          onChange={props.changed}
        >
          placeholder= {props.placeholder}
          onKeyPress={props.onKeyPress}
          {props.elementConfig.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    default:
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          onKeyPress={props.onKeyPress}
          onChange={props.changed}
          placeholder={props.placeholder}
        />
      );
  }

  return (
    <div className={classes.Input}>
      {/* <label className={classes.Label}>{props.label}</label> */}
      {inputElement}
    </div>
  );
};

export default input;
